import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { useCommonStyles } from './styles';

const useStyles = makeStyles((theme) => ({
  rootContainer: {},
  title: {
    paddingTop: 16,
  },
  subTitle: {
    padding: '4px 0',
  },
  description: {
    paddingBottom: 16,
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconStyles: {
    width: 32,
    height: 32,
    background: (props) => (props.mode === 'dark' ? '#191826' : '#EEF5FE'),
    borderRadius: '100%',
    padding: 12,
  },
}));

const MatchingDetailsTimelineCard = ({
  rootClass = '',
  iconImg = '',
  title = '',
  subTitle = '',
  description = '',
  mode,
}) => {
  const classes = useStyles({ mode });
  const commonClasses = useCommonStyles({ mode });

  return (
    <Grid container classes={{ root: clsx(classes.rootContainer, rootClass) }}>
      <Grid item xs={2} classes={{ root: classes.iconContainer }}>
        <img src={iconImg} alt={title} className={classes.iconStyles} />
      </Grid>
      <Grid item xs={10}>
        <Typography
          classes={{ root: clsx(commonClasses.fontRegular, classes.title) }}
        >
          {title}
        </Typography>
        <Typography
          classes={{
            root: clsx(commonClasses.fontRegularLight, classes.subTitle),
          }}
        >
          {subTitle}
        </Typography>
        <Typography
          classes={{
            root: clsx(commonClasses.fontRegularLight, classes.description),
          }}
        >
          {description}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default MatchingDetailsTimelineCard;
